<template>
  <ModalWindow @close="$emit('close')">
    <div class="bb-excel">
      <h2 class="bb-excel__title">Export to Excel</h2>
      <div class="bb-excel-body">
        <div class="bb-excel-body-ready" v-show="readyExcel">
          <span>Your file is ready to download.</span>
          <span>Click on download</span>
          <a class="bb-excel-body-item__button bb-excel-body-item__button_download bb-button"
             v-if="loaderRun || readyExcel"
             @click.stop="downloadExcel"
             target="_blank"
             ref="downloadExcel">
            DOWNLOAD
          </a>
        </div>
        <div class="bb-excel-body-item"
             v-if="columns && columns.length"
             v-for="column in columns"
             :key="column.title">
          <div class="bb-excel-body-item__title">{{column.title}}</div>
          <checkbox class="bb-excel-body-item__checkbox"
                    :name="column"
                    @checkboxChange="checkboxChange"
                    :value="true"/>
        </div>
      </div>
      <transition name="fade" mode="in-out">
        <LoaderFly :block-mode="true" v-if="loaderRun"/>
      </transition>
    </div>
    <template v-slot:buttons>
      <template v-if="!loaderRun && !readyExcel">
        <button class="bb-excel-body-item__button bb-button" @click.stop="startExport">EXPORT</button>
      </template>
    </template>
  </ModalWindow>
</template>

<script>
import Checkbox from '@/components/Main/Inputs/checkbox'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import _ from 'lodash'

export default {
  name: 'ExportExcel',
  components: {
    Checkbox,
    ModalWindow,
    LoaderFly
  },
  props: ['columns', 'generateExcel', 'data', 'fileName', 'withoutColumns', 'keyColumnsSettings'],
  data () {
    return {
      linkToFile: '#',
      readyExcel: false,
      loaderRun: false,
      selectedColumns: []
    }
  },
  methods: {
    checkboxChange (data, item) {
      const index = _.findIndex(this.selectedColumns, item)
      if (index !== -1 && !data) {
        this.selectedColumns.splice(index, 1)
      } else {
        this.selectedColumns.push(item)
      }
      const sortedColumns = _.sortBy(this.selectedColumns, ['$position'])
      this.$emit('changeColumns', sortedColumns)
    },
    setColumns (columns) {
      const res = {}
      _.forEach(columns, item => {
        _.set(res, item.property, item.title)
      })
      return res
    },
    async startExport () {
      const params = _.cloneDeep(this.data)
      params[this.keyColumnsSettings || 'body'] = this.setColumns(this.selectedColumns)
      this.loaderRun = true
      const resp = await this.generateExcel(params)
      const link = this.$refs.downloadExcel
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const filename = this.fileName ? `bb-${this.fileName}-report.xls` : 'bb-report.xls'
      link.href = url
      link.setAttribute('download', filename)
      this.readyExcel = true
      this.loaderRun = false
    },
    downloadExcel () {
      this.$emit('close')
    }
  },
  beforeMount () {
    this.columns = _.forEach(this.columns, (item, index) => {
      item.$position = index
    })
    this.selectedColumns = _.cloneDeep(this.columns)
    this.$emit('changeColumns', this.selectedColumns)
    if (this.withoutColumns) {
      this.startExport()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-excel {
    @include global-font;
    position: relative;
    min-width: 398px;
    max-height: 300px;
    min-height: 150px;

    &__title {
      position: relative;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      z-index: 1000;
    }

    &-body {
      margin-top: 25px;

      &-ready {
        position: absolute;
        top: 0;
        left: 0;
        padding-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-color: $color-white;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        z-index: 2;
      }

      &-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 18px;

        &:last-child {
          margin-bottom: 0;
        }

        &__title {
          color: $color-accent;
          font-style: normal;
          font-weight: bold;
          font-size: 12px;
          line-height: 14px;
          user-select: none;
        }

        &__button {
          width: 94px;
          height: 42px;
          margin: 14px auto 0;
          text-decoration: none;

          &_download {
            width: 114px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/ExportExcel/ExportExcel.vue